var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#back';
                    var viewUrl = 'svg/global.svg#view-back';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };